import React from "react";
import t from "module/translations";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const CertificationSessionTableHead: React.FC = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left">
          {t.competencyManagement.certification.session.nameHeader}
        </TableCell>
        <TableCell align="left">
          {t.competencyManagement.certification.session.achievedHeader}
        </TableCell>
        <TableCell align="left">
          {t.competencyManagement.certification.session.remarksHeader}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default React.memo(CertificationSessionTableHead);
